import { useState } from "react";
import { useTranslation } from "react-i18next";


const UploadImage: React.FunctionComponent<{ OnUploadImages: any }> = (props) => {

    const [isHovered, setIsHovered] = useState<boolean>(false);
    const [selectWatermark, setSelectWatermark] = useState<any>([]);
    const { t } = useTranslation();

    function getRandomSixDigitNumber(): number {
        return Math.floor(100000 + Math.random() * 900000);
    }

    const HandleChangeUpload = async (event: any) => {
        const files = event.target.files;
        const updatedImages: any[] = [];
        const fileReaders = Array.from(files).map((file: any, index) => {
            return new Promise<void>((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const base_64 = reader.result as string;
                    const ext = file.type.split('/')[1];
                    const image = {
                        id: getRandomSixDigitNumber(),
                        src: base_64,
                        ext: ext,
                    };
                    setSelectWatermark((prevSelectedImages: any) =>
                        [...prevSelectedImages, image]
                    );
                    updatedImages.push(image);
                    resolve();
                };
            });
        });

        await Promise.all(fileReaders);
        props.OnUploadImages(updatedImages);
    }


    const handleDeleteWatermark = (idToDelete: any) => {
        const updatedImages = selectWatermark.filter((image: any) => image.id !== idToDelete);
        setSelectWatermark(updatedImages);
    };



    return (
        <>
            {selectWatermark.length == 0 ?
                <div className="upload-xml mt-2">
                    <label className="form-container" id="upload-container">
                        <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_830_8176)">
                                <path d="M8.83301 35.417V39.5837C8.83301 40.6887 9.27199 41.7485 10.0534 42.5299C10.8348 43.3113 11.8946 43.7503 12.9997 43.7503H37.9997C39.1047 43.7503 40.1645 43.3113 40.9459 42.5299C41.7273 41.7485 42.1663 40.6887 42.1663 39.5837V35.417" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M8.83301 35.417V39.5837C8.83301 40.6887 9.27199 41.7485 10.0534 42.5299C10.8348 43.3113 11.8946 43.7503 12.9997 43.7503H37.9997C39.1047 43.7503 40.1645 43.3113 40.9459 42.5299C41.7273 41.7485 42.1663 40.6887 42.1663 39.5837V35.417" stroke="black" strokeOpacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15.083 18.7497L25.4997 8.33301L35.9163 18.7497" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15.083 18.7497L25.4997 8.33301L35.9163 18.7497" stroke="black" strokeOpacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M25.5 8.33301V33.333" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M25.5 8.33301V33.333" stroke="black" strokeOpacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_830_8176">
                                    <rect width="50" height="50" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>

                        <p className="mt-2">{t("propertyDetails.uploadImages")}</p>
                        <input className="form__file" id="upload-files" accept="image/*" type="file" onChange={HandleChangeUpload} />
                    </label>
                    <div id="files-list-container"></div>
                </div> :
                <div id="read-watermark" onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)} style={{ height: "190px" }}>
                    {selectWatermark && selectWatermark.map((image: any, index: any) => {
                        return <div key={index} style={{ position: "relative", display: "inline-block" }}>
                            <img src={image.src} className="previewImage" id={`previewImage-${index}`} style={{ width: "190px", marginLeft: "0px" }} key={index} />
                            <button
                                style={{ position: "absolute", top: "5px", right: "25px", borderRadius: "50px", color: "#716BE3", border: "2px solid #716BE3", background: "#FFF" }}
                                onClick={() => handleDeleteWatermark(image.id)}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                    })}
                </div>}
        </>
    )
}
export default UploadImage;